import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
// import colors from 'styles/colors';

const Svg = styled.svg`
  height: 24px;
  width: 24px;
  fill: none;
`;

function Checkbox({ className, selected }) {
  return (
    <Svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {selected ? (
        <>
          <rect
            width="24"
            height="24"
            rx="5"
            strokeWidth="2"
            fill={selected ? '#0246E3' : 'none'}
            stroke={selected ? 'none' : '#A3AACC'}
          />
          <path
            d="M6 12.5L9.96415 17L18 8"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ) : (
        <rect
          x="0.75"
          y="0.75"
          width="22.5"
          height="22.5"
          rx="4.25"
          fill="white"
          stroke="#A3AACC"
          strokeWidth="1.5"
        />
      )}
    </Svg>
  );
}

Checkbox.propTypes = {
  className: PropTypes.string,
  selected: PropTypes.bool,
};

export default Checkbox;
